<template>
  <div>
    <PageTitle title="Kitchens" :btnCreate="false" />
    <ValidationObserver ref="createObserver" v-slot="{ validate }" class="px-6">
      <tr v-if="editKitchenId == null">
        <th>
          <ValidationProvider
            v-slot="{ errors }"
            name="name"
            vid="name"
            rules="required|no_spaces_only|min:3"
          >
            <v-col cols="12" class="pl-0">
              <v-text-field
                :error-messages="errors"
                required
                dense
                label="Name"
                v-model="newKitchen.name"
                outlined
                @blur="newKitchen.name = newKitchen.name.trim()"
              ></v-text-field>
            </v-col>
          </ValidationProvider>
        </th>

        <th class="title">
          <v-col cols="4">
            <permission-control permissionName="Kitchen Create">
              <v-btn
                @click="SaveKitchen()"
                depressed
                small
                class="text-white btn_blue btn_medium w-100"
                >Create</v-btn
              >
            </permission-control>
          </v-col>
        </th>
      </tr>
    </ValidationObserver>

    <v-container fluid class="lighten-12 content">
      <ValidationObserver ref="observer" v-slot="{ validate, reset }">
        <v-card class="lighten-12 card-content mb-2">
          <v-row class="ma-0 align-right">
            <TableFilters
              :filters="['status', 'search']"
              v-model="filter"
              :columns="columns"
            ></TableFilters>
            <ImportExportMenu :permission="'Place Report'"></ImportExportMenu>
          </v-row>
        </v-card>

        <LoadingComponent
          v-if="isLoading"
          :visible="isLoading"
        ></LoadingComponent>
        <v-card class="lighten-12 mt-2">
          <v-container fluid class="light gray lighten-12">
            <v-row>
              <v-card-text class="pa-0">
                <v-data-table
                  :items-per-page="paginationOptions.perPage"
                  :fixed-header="true"
                  :headers="headers"
                  :items="kitchens"
                  item-key="id"
                  hide-default-footer
                >
                  <!-- No -->
                  <template v-slot:item.no>
                    <v-icon>mdi-vuetify</v-icon>
                  </template>
                  <!-- Name -->
                  <template v-slot:item.name="{ item }"
                    ><ValidationProvider
                      v-slot="{ errors }"
                      name="Name"
                      vid="name"
                      v-if="item.id == editKitchenId"
                      rules="required|no_spaces_only|min:3"
                    >
                      <v-text-field
                        v-model="newKitchen.name"
                        :error-messages="errors"
                        :value="item.name"
                        outlined
                        class="pt-3"
                        @blur="newKitchen.name = newKitchen.name.trim()"
                      ></v-text-field>
                    </ValidationProvider>
                    <p v-else>{{ item.name }}</p>
                  </template>

                  <!-- Status -->
                  <template v-slot:item.status="{ item }" :slot-scope="props">
                    <toggle-button
                      v-model="newKitchen.is_active"
                      v-if="editKitchenId == item.id"
                      :disabled="editKitchenId != item.id"
                      :value="item.is_active"
                      :width="80"
                      :labels="{ checked: 'Active', unchecked: 'Archeived' }"
                    ></toggle-button>
                    <v-chip
                      v-else
                      :x-small="true"
                      class="ma-2"
                      label
                      text-color="white"
                      :color="getStatusColor(item.is_active)"
                      dark
                      >{{ item.is_active ? "Active" : "Archived" }}</v-chip
                    >
                  </template>

                  <!-- Action -->
                  <template v-slot:item.action="{ item }">
                    <v-menu offset-y transition="scroll-y-transition">
                      <template v-slot:activator="{ attrs, on }">
                        <v-icon
                          v-show="editKitchenId != item.id"
                          v-bind="attrs"
                          v-on="on"
                          >mdi-dots-vertical</v-icon
                        >
                        <v-btn
                          v-show="editKitchenId == item.id"
                          color="secondary"
                          fab
                          x-small
                          dark
                          class="ma-1"
                        >
                          <v-icon
                            depressed
                            small
                            link
                            @click="CancelKitchen(item)"
                            >clear</v-icon
                          ></v-btn
                        >
                        <v-btn
                          v-show="editKitchenId == item.id"
                          color="green"
                          fab
                          x-small
                          dark
                          ><v-icon link @click="UpdateKitchen(item)"
                            >done</v-icon
                          ></v-btn
                        >

                        <!-- {{editKitchenId==item.id}} -->
                      </template>

                      <v-list class="actions">
                        <permission-control permissionName="Place Edit">
                          <v-list-item link @click="Editplace(item)">
                            <span>
                              <v-icon v-bind="attrs" v-on="on"
                                >mdi-pencil-box-outline</v-icon
                              >Edit
                            </span>
                          </v-list-item>
                        </permission-control>
                        <permission-control permissionName="Place Soft Delete">
                          <v-list-item link @click="openConfirmation(item)">
                            <span>
                              <v-icon v-bind="attrs" v-on="on">
                                {{
                                  item.is_active
                                    ? "mdi-archive"
                                    : "mdi-checkbox-marked-circle"
                                }}
                              </v-icon>
                              {{ item.is_active ? "Archieve" : "Active" }}
                            </span>
                          </v-list-item>
                        </permission-control>
                        <permission-control permissionName="Place Soft Delete">
                          <v-list-item
                            link
                            dense
                            @click="onDeleteClickedItem(item)"
                          >
                            <span>
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-delete
                              </v-icon>
                              Delete
                            </span>
                          </v-list-item>
                        </permission-control>
                      </v-list>
                    </v-menu>
                  </template>
                  <template v-slot:footer>
                    <pagination
                      @paginationOptions="setPaginationOptions"
                      @response="setResponseData"
                      url="hms/kitchens"
                      :filter="filter"
                      ref="pagination"
                    >
                    </pagination>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-row>
          </v-container>
        </v-card>
      </ValidationObserver>
      <!-- </v-card> -->
      <div class="d-flex justify-center align-center"></div>
    </v-container>
  </div>
</template>
<script>
import TableFilters from "@/components/base/TableFilters";

import { required, email, max, min, regex } from "vee-validate/dist/rules";
import { mapState } from "vuex";
import pagination from "../../shared/components/pagination";
import confirmation from "../../shared/components/confirmation";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} is required",
});

extend("no_spaces_only", {
  validate: (value) => {
    return value && value.trim().length > 0;
  },
  message: "{_field_} cannot be empty or spaces only",
});

extend("max", {
  ...max,
  message: "{_field_} may not be greater than {length} characters",
});

extend("min", {
  ...min,
  message: "{_field_} must be at least {length} characters",
});

extend("email", {
  ...email,
  message: "Email must be valid",
});
extend("regex", {
  ...regex,
  message: "The value is not a valid phone number",
});
export default {
  components: {
    pagination,
    ValidationProvider,
    TableFilters,
    ValidationObserver,
  },
  data() {
    return {
      kitchens: [],
      paginationOptions: {},
      isLoading: false,
      pagination1: {
        descending: true,
        page: 1,
        rowsPerPage: 2,
        sortBy: "fat",
        totalItems: 0,
        KitchenErrors: null,
        rowsPerPageItems: [1, 2, 4, 8, 16],
      },
      guest: [],
      pagination: {
        page: 1,
        itemsPerPage: 2,
      },
      page: 1,
      status: [
        { text: "Active", value: "active" },
        { text: "Archived", value: "archived" },
      ],
      columns: [
        {
          text: "Name",
          value: "name",
          show: true,
          disabled: false,
          width: "40%",
        },

        {
          text: "Status",
          value: "status",
          show: true,
          disabled: false,

          width: "40%",
        },
        {
          text: "Actions",
          value: "action",
          show: true,
          disabled: false,

          width: "40%",
        },
      ],
      newKitchen: { name: "", id: "", is_active: "" },
      filter: {
        name: "",
        search: "",
        status: "",
      },

      // For edit purpose
      editKitchenId: null,
    };
  },
  methods: {
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    clearFilter() {
      this.filter = {};
    },
    refreshData() {
      this.$refs.pagination.refreshData();
    },
    setResponseData(kitchen) {
      this.kitchens = kitchen;
    },

    CancelKitchen(item) {
      this.refreshData();
      this.editKitchenId = null;
      this.newKitchen = {};
    },
    SaveKitchen() {
      const isValid = this.$refs.observer.validate();
      if (isValid) {
        this.isLoading = true;
        this.CreateKitchens();
      }
    },

    CreateKitchens() {
      let Kitchenname = this.newKitchen;
      this.$store
        .dispatch("Kitchen/CreateKitchens", Kitchenname)
        .then((res) => {
          //this.succeeed = true;

          this.$toast.success("Kitchen created  succesfully");
          this.refreshData();
          this.$refs.createObserver.reset();
          this.isLoading = false;
          this.newKitchen = {};
        })
        .catch((err) => {
          this.$refs.observer.setErrors(err.data.error);
          this.$toast.error("Kitchen created  failed");
          this.messages = err.data.title;
          this.isLoading = false;
        });
    },
    onDeleteClickedItem(item) {
      confirmation.dialog = true;
      this.$confirm("Do you want to " + "Delete " + item.name + " ?").then(
        (res) => {
          if (res) {
            this.$store
              .dispatch("Kitchen/DeleteKitchen", item.id)
              .then((res) => {
                this.refreshData();
                const msg = item.name + " deleted";
                this.$toast.success("Successfully  " + msg);
              })
              .catch((err) => {
                this.$toast.error(item.name + " is not deleted");
              });
          } else {
          }
        }
      );
    },
    UpdateKitchen(data) {
      let kitchen = _.cloneDeep(this.newKitchen);
      let promise = Promise.resolve();

      if (kitchen.is_active !== data.is_active) {
        promise = this.$store.dispatch(
          "Kitchen/ActiveOrArchiveKitchens",
          data.id
        );
      }

      promise
        .then(() => {
          return this.$store.dispatch("Kitchen/EditKitchens", kitchen);
        })
        .then((res) => {
          this.editKitchenId = null;
          this.newKitchen = {};
          this.$toast.success("Kitchen edited successfully");
          this.$refs.observer.reset();
          this.refreshData();
        })
        .catch((err) => {
          if (err.data && err.data.error) {
            this.$refs.observer.setErrors(err.data.error);
            this.KitchenErrors = err.data.error.name;
          }
          this.messages = err.data ? err.data.title : "";
          this.$toast.error("Kitchen edited failed");
        });
    },

    Editplace(data) {
      this.newKitchen = _.cloneDeep(data);
      this.editKitchenId = data.id;
    },
    getStatusColor(is_active) {
      return is_active ? "green" : "gray";
    },
    openConfirmation(Place) {
      confirmation.dialog = true;
      this.$confirm(
        "Do you want to " +
          (Place.is_active ? "Archive " : "Active ") +
          Place.name +
          " ?"
      ).then((res) => {
        if (res) {
          this.$store
            .dispatch("Kitchen/ActiveOrArchiveKitchens", Place.id)
            .then((res) => {
              this.refreshData();
              const msg = Place.is_active ? "archived" : "activated";
              this.$toast.success("Successfully  " + msg);
            })
            .catch((err) => {
              this.$toast.error("Kitchen is not Archived");
            });
        } else {
        }
      });
    },
  },
  computed: {
    headers: function() {
      return this.columns.filter((item) => item.show == true);
    },
  },
  created() {
    this.refreshData();
  },
};
</script>
